import { MarcadorDto } from "@/interfaces/marcador.interface";
import { IConfiguracaoPaginatedRequest } from "@/interfaces/paginated.interface";
import { downloadFile } from "@/lib/utils";
import { createBaseApi } from "./base.service";
import { store } from "@/redux/store";
import { SetLocais } from "@/redux/slices/login.slice";
import { RESOURCES } from "./resources";
import { LocalDto } from "@/interfaces/local.interface";

export const localApi = createBaseApi<LocalDto>(RESOURCES.LOCAIS);

export const localAPI = localApi.injectEndpoints({
  endpoints: (build) => ({
    postLocal: build.mutation<any, MarcadorDto>({
      query: (body) => ({
        url: `/locais`,
        method: "POST",
        body,
      }),
      invalidatesTags: () => [
        { type: "LocaisLogin" },
        { type: "Locais", id: "PARTIAL-LIST" },
        { type: "Agendamentos", id: "PARTIAL-LIST" },
      ],
    }),
    getLocais: build.query<any, number>({
      query: () => ({
        url: `/locais/byLogin`,
        method: "GET",
      }),
      providesTags: () => [{ type: "LocaisLogin" }],
      async onQueryStarted(_query, { dispatch, queryFulfilled }) {
        const { data } = await queryFulfilled;
        dispatch(SetLocais(data));
      },
    }),
    deleteLocais: build.mutation<any, number>({
      query: (id) => ({
        url: `/locais/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: () => [
        { type: "Locais", id: "PARTIAL-LIST" },
        { type: "LocaisLogin" },
        { type: "Agendamentos", id: "PARTIAL-LIST" },
      ],
    }),
    getLocaisPaginated: build.query<any, IConfiguracaoPaginatedRequest>({
      query: (params) => ({
        url: `/locais`,
        params,
        method: "GET",
      }),
      providesTags: () => [{ type: "Locais", id: "PARTIAL-LIST" }],
    }),
    extractExcelLocais: build.mutation<any, IConfiguracaoPaginatedRequest>({
      queryFn: async (
        { configuracaoId, filename, campos },
        api,
        extraOptions,
        baseQuery
      ) => {
        const result = await baseQuery({
          url: `/locais`,
          params: {
            extract: "excel",
            campos,
            filename,
          },
          method: "GET",
          responseHandler: (response) => response.blob(),
        });
        return downloadFile(result, filename);
      },
    }),
  }),
});

export const {
  useDeleteLocaisMutation,
  useExtractExcelLocaisMutation,
  useGetLocaisPaginatedQuery,
  useGetLocaisQuery,
  usePostLocalMutation,
} = localAPI;
